<footer class="footer container-fluid" id="footer">
  <hr>
  <div class="container">
    <div>
      <div class="d-flex flex-column justify-content-center text-light gap-4">
          <span>
            <img alt="logo" loading="lazy" src="/images/baazar.svg" width="80">
          </span>
        <a href="https://baazar.ir/mag/" rel="noopener" style="color: white;text-decoration:none" target="_blank">
          مجله بازر
        </a>
        <a [routerLink]="'/Roles'" style="text-decoration: none;color: white">
            فوانین و مقررات
        </a>
      </div>

      <div class="d-flex flex-column justify-content-center text-light gap-4 text-center">
        <div class="title">
          تماس با ما
        </div>
        <div class="d-flex justify-content-center align-items-center flex-column">
          <mat-icon>phone</mat-icon>
          <a href="tel:+982165013024" style="color: white;text-decoration:none">02165013024</a>
          <a href="tel:+982165013095" style="color: white;text-decoration:none">02165013095</a>
          <a href="tel:+989105698040" style="color: white;text-decoration:none">09105698040</a>
        </div>
        <div class="d-flex justify-content-center align-items-center flex-column">
          <mat-icon>email</mat-icon>
          <span>
            <a href="mailto:info@baazar.ir" style="color: white;text-decoration:none">info&#64;baazar.ir</a>
          </span>
        </div>
      </div>

      <div class="d-flex flex-column align-items-center justify-content-center text-light gap-4">
        <div class="d-flex justify-content-center align-items-center flex-column">
          <mat-icon>location_on</mat-icon>
          <span class="text-center">
              دفتر پشتیبانی و فنی: تهران، طرشت، بلوار شهید جواد اکبری،خیابان شهدای طرشت جنوبی،کارخانه نوآوری بایوتکس
          </span>
          <span class="text-center mt-2">
              دفتر معاملات: کرج، چهارراه امام، خیابان شهید دکتر بهشتی، خیابان دکتر همایون، پلاک 25، طبقه همکف
شماره تماس : 02632284227
          </span>
        </div>
        <div class="d-flex gap-3">
            <img (click)="openAparatLink()" alt="aparat" loading="lazy" src="/images/aparat.png" width="26">
            <img (click)="openBaleLink()" alt="bale" loading="lazy" src="/images/ic_bale.svg" width="26">
            <img (click)="openTelegramLink()" alt="telegram" loading="lazy" src="/images/telegram.png" width="26">
            <img (click)="openInstagramLink()" alt="instagram" loading="lazy" src="/images/instagram.png" width="26">
        </div>
        <div class="d-flex flex-wrap justify-content-center">
          <div class="p-1">
            <div class="d-flex justify-content-center align-items-center w-100 gap-3">
              <a href="https://apinovin.iranianasnaf.ir/parvaneh/e5247e63-8197-4320-9685-eeab0b36c20a/html" rel="noopener" target="_blank"><img alt="" class="aligncenter wp-image-2098 size-thumbnail" height="150" src="/images/etehadiekeshvaripng.parspng.com_.png" width="150"/></a>
            </div>
          </div>
          <div class="p-1">
            <div class="d-flex justify-content-center align-items-center w-100 gap-3">
              <a href="https://trustseal.enamad.ir/?id=431994&amp;Code=OpwuFXuOJW5EGgfr3gwACLRt5BBntJWI" rel="noopener" target="_blank"><img alt="" class="aligncenter" src="https://trustseal.enamad.ir/logo.aspx?id=431994&amp;Code=OpwuFXuOJW5EGgfr3gwACLRt5BBntJWI" style="cursor: pointer;"/></a>
            </div>
          </div>
          <div class="p-1">
            <div class="d-flex justify-content-center align-items-center w-100 gap-3">
              <a href="https://logo.samandehi.ir/Verify.aspx?id=1041133&amp;p=rfthobpdaodsrfthrfthxlaoxlao"><img alt="logo-samandehi" class="aligncenter" id="jxlzesgtwlaojxlzjxlzrgvjrgvj" src="https://logo.samandehi.ir/logo.aspx?id=1041133&amp;p=nbpdlymashwlnbpdnbpdqftiqfti" style="cursor: pointer;"/></a>
            </div>
          </div>
          <div class="p-1">
            <div class="d-flex justify-content-center align-items-center w-100 gap-3">
                <a href=""><img alt="" class="size-full wp-image-2032 aligncenter" height="150" loading="lazy"
                                src="/images/images-1-1.png" width="150"/></a>
            </div>
          </div>
          <div class="p-1">
            <div (click)="showFullImage('/images/parvane_kasb1.png', $event)" class="d-flex justify-content-center align-items-center w-100 gap-3">
                <a href=""><img alt="" class="size-full wp-image-2032 aligncenter" height="150" loading="lazy"
                                src="/images/etehadie_tala.png" width="150"/></a>
            </div>
          </div>
          <div class="p-1">
            <div (click)="showFullImage('/images/faaliat.jpg', $event)" class="d-flex justify-content-center align-items-center w-100 gap-3">
                <a href=""><img alt="" class="size-full wp-image-2032 aligncenter" height="150" loading="lazy"
                                src="/images/nezam_senfi.png" width="150"/></a>
            </div>
          </div>
        </div>

      </div>

      <div class="d-flex flex-column justify-content-center text-light gap-4">
        <!--          <span class="title">-->
        <!--            عضویت در خبرنامه بازَر-->
        <!--          </span>-->
        <!--        <input placeHolder="ایمیل" type="text">-->
        <span class="title">
            اپلیکیشن بازَر
          </span>
        <span>پشتیبانی:
شنبه تا چهارشنبه 9 الی 18
          </span>
        <span>پنج شنبه 9 الی 14</span>

        <div class="d-flex gap-2 flex-wrap ">

            <img (click)="openBazarLink()" alt="" loading="lazy" src="/images/download-from-bazar.png" width="140">
          <!--          <img (click)="openGooglePlayLink()" alt="" src="/images/download-from-playstor.png" width="140">-->
            <img (click)="openMayketLink()" alt="" loading="lazy" src="/images/download-from-myket.png" width="140">
        </div>
      </div>

    </div>
  </div>
  <div *ngIf="fullImage" class="full-image-container">
    <img [src]="fullImage" class="full-image">
    <button (click)="fullImage = null">X</button>
  </div>
</footer>
<footer class="footer container-fluid">
  تمامی حقوق مادی و معنوی برای این سایت محفوظ است.
</footer>
